import {Control, Controller, FieldPath, FieldValues, PathValue, Path} from "react-hook-form";
import {FilledInput, FormControl, FormHelperText, MenuItem, Select} from "@mui/material";
import {HasId} from "../../types/hasId";

export interface Props<TOptions extends HasId, TFieldValues extends FieldValues = FieldValues> {
    name: FieldPath<TFieldValues>;
    control: Control<TFieldValues>;
    options: TOptions[];
    isLoading?: boolean;
    initialValue?: PathValue<TFieldValues, Path<TFieldValues>>;
    getOptionLabel: (option: TOptions) => string;
    disabled?: boolean;
}

// TODO: IsLoading support
export const SelectInput = <TOptions extends HasId, TFieldValues extends FieldValues = FieldValues>(
    props: Props<TOptions, TFieldValues>,
) => {
    const {name, control, options, initialValue, getOptionLabel, disabled} = props;

    return (
        <Controller
            name={name}
            control={control}
            defaultValue={initialValue}
            render={({field: {onChange, value}, fieldState: {error}}) => (
                <FormControl fullWidth error={!!error} data-test={name}>
                    <Select
                        margin="none"
                        size="small"
                        id="name"
                        fullWidth
                        variant="filled"
                        onChange={onChange}
                        value={value}
                        disabled={disabled ?? false}
                        input={<FilledInput disableUnderline hiddenLabel sx={{background: "#E9EBF1"}} />}
                    >
                        {options.map((option) => (
                            <MenuItem key={option.id} value={option.id}>
                                {getOptionLabel(option)}
                            </MenuItem>
                        ))}
                    </Select>
                    {error && <FormHelperText>{error.message}</FormHelperText>}
                </FormControl>
            )}
        ></Controller>
    );
};
